import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import ReactMarkdown from "react-markdown";
import MessageModal from '../container/MessageModal';
import MostrarPostutacion from '../container/MostrarPostutacion';
import {useReactToPrint} from 'react-to-print';
import { errorClassification } from '../errorHandler';

import ofertasServices from '../services/ofertasServices';

const OfertaShow = () => {
  const [authInformation, setAuthInformation] = useContext(InputContext)

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  })

  const [oferta, setOferta] = useState({});
  let { id } = useParams();

  // modal messages
  const [showModal, setShowModal] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const handleShowModal = (message) => {setModalBody(message); setShowModal(true)};
  const handleCloseModal = () => { setShowModal(false); setModalBody('') };

  const imprimirPostulacion = () => {
    handlePrint()
  }

  useEffect(() => {
    fetchOferta(id)
  }, [id]);

  const fetchOferta = async (id) => {
    try {
      const data = await ofertasServices.obtenerOfertaPorId(id);
      setOferta(data);

    } catch (error) {
      const result = errorClassification(error)
      if(result.modal){
        handleShowModal(result.message)
      }
    }
  };

  const convertToTitleCase = (str) => {
    if(str){
      return str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
    }
  }

  return (
    <>
      {/* <pre>{JSON.stringify(postulacion, null, 2)}</pre> */}
      {
        oferta && oferta.titulo && ( authInformation.rol === 'Admin' || oferta.activo ) && (
          <div className="px-4 py-2" ref={componentRef}>
            <h3 className="text-center text-secondary">{convertToTitleCase(oferta.tipos)}</h3>
            <h1 className="fw-bold text-center text-body-emphasis">{oferta.titulo}</h1>
            <h3 className="fw-bold text-center text-body-emphasis"><span className="badge fs-6 bg-secondary">{oferta.cargo.codigo} - {oferta.cargo.nombre} - {oferta.cargo.agrupamiento}</span></h3>

            <div className="col-lg-6 mx-auto">
              <ReactMarkdown className="mb-4 text-left justified-text" children={oferta.detalle} />
            </div>
            <MostrarPostutacion usuarioId={authInformation.user_id} valorOferta={oferta} imprimirPostulacion={imprimirPostulacion} />
          </div>
        )
      }
     <MessageModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalBody={modalBody}
     />
    </>
  );
};

export default OfertaShow;